import $http from "../axios";

const state = {
  transactions: []
};

const getters = {
  transactions: state => {
    return state.transactions;
  },
  transactionsReverse: state => {
    return JSON.parse(JSON.stringify(state.transactions.reverse()));
  }
};

const actions = {
  getTransactions({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `transactions?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            console.log("Transactions: ", res.data.payload);
            commit("SET_TRANSACTIONS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  changeOrderStatus(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-order-status`, data)
        .then(res => {
          if (res.data.result === "ok") {
            const index = state.transactions.findIndex(
              transaction => transaction._id === data._id
            );

            if (index !== -1) {
              state.transactions[index].orderLifecycle.status = data.status;
            }
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_TRANSACTIONS(state, payload) {
    state.transactions = payload.transactions;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
